__webpack_require__.f = {};
// This file contains only the entry chunk.
// The chunk loading function for additional chunks
__webpack_require__.e = function(chunkId, fetchPriority) {
	var promises = [];
	__webpack_require__.f.j(chunkId, promises, fetchPriority);
	return Promise.all(promises);
};